module.exports = __webpack_public_path__ + "static/media/cintilloLogo.2681a1ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cintilloLogo.svg
// module id = 731
// module chunks = 0